import { addDays, zonedDayStart } from "@commerce-os/utils";

/** URL search of the inventory pages, so a history view or a prefilled form can be shared or reloaded. */

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const day = /^\d{4}-\d{2}-\d{2}$/;
const id = (value: unknown) => (typeof value === "string" && uuid.test(value) ? value : undefined);
const date = (value: unknown) => (typeof value === "string" && day.test(value) ? value : undefined);

export interface HistorySearch {
  variantId?: string;
  locationId?: string;
  /** Calendar days (`2026-10-24`) in the tenant's zone; `to` is inclusive. */
  from?: string;
  to?: string;
}

export function historySearch(search: Record<string, unknown>): HistorySearch {
  const out: HistorySearch = {};
  for (const key of ["variantId", "locationId"] as const) {
    const value = id(search[key]);
    if (value !== undefined) out[key] = value;
  }
  for (const key of ["from", "to"] as const) {
    const value = date(search[key]);
    if (value !== undefined) out[key] = value;
  }
  return out;
}

/** Days → instants in the tenant's zone: `from` at its start, `to` up to the next day's start (exclusive). */
export function historyRange(search: HistorySearch, timeZone: string): { from?: string; to?: string } {
  return {
    ...(search.from === undefined ? {} : { from: zonedDayStart(search.from, timeZone) }),
    ...(search.to === undefined ? {} : { to: zonedDayStart(addDays(search.to, 1), timeZone) }),
  };
}

export interface AdjustmentFormSearch {
  mode: "adjust" | "opening";
  locationId?: string;
  variantId?: string;
}

export function adjustmentFormSearch(search: Record<string, unknown>): AdjustmentFormSearch {
  const out: AdjustmentFormSearch = { mode: search["mode"] === "opening" ? "opening" : "adjust" };
  for (const key of ["variantId", "locationId"] as const) {
    const value = id(search[key]);
    if (value !== undefined) out[key] = value;
  }
  return out;
}
